module.exports = __webpack_public_path__ + "media/social-media/icon-email-228d3c57.svg";